'use strict';

angular.module('TurneroApp').service('llamadorService', ['$resource', 'portal', function ($resource, portal) {
    return $resource(portal.getUrlServer() + 'api/Llamador/:id', { id: '@Id_Llamador' }, {
        listadoTurnosLlamador: {
            method: 'GET',
            params: {
                id_centro_atencion: 'id_centro_atencion'
            },
            url: portal.getUrlServer() + 'api/Llamador/listadoTurnosLlamador/',
        },
        Configuracion_Llamador: {
            method: 'GET',
            params: {
                id_centro_atencion: '@id_centro_atencion',
                clave_autogestion: '@clave_autogestion'
            },
            url: portal.getUrlServer() + 'api/Llamador/configuracion/'
        },
        update: {
            method: 'PUT',
        }
    });
}]);



// WEBPACK FOOTER //
// ./app/components/llamador/llamadorService.js